import { Ionicons } from '@expo/vector-icons';
import { Tabs } from 'expo-router';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';

import { AddExpenseFab } from '@/components/ui/fab';
import { useAuthStore } from '@/store/auth-store';
import { colors, fonts } from '@/theme/tokens';

/**
 * Budget-first navigation (decision 2026-07-10, reshaped 2026-07-11 per mock
 * start_nowa_nawigacja): the "Dodaj" tab became a global FAB, freeing the slot
 * for the Budżet month summary; policies stay second-but-not-secondary at the
 * end of the bar. Since 2026-07-11 the "Więcej" tab is gone for everyone (its
 * screen lives behind the header avatar as /menu) — the freed slot shows the
 * AGENT tab, but ONLY when the logged-in account is a detected agent (Żaneta's
 * requirement: agents work from the phone). href:null hides the tab entirely
 * for regular clients while keeping the route registered.
 */
export default function TabsLayout() {
  const { t } = useTranslation();
  const isAgent = useAuthStore((s) => s.isAgent);
  // Admin (CRM role=admin matched by phone) gets the same tab in admin view.
  const isAdmin = useAuthStore((s) => s.isAdmin);
  return (
    <View style={{ flex: 1 }}>
      <Tabs
        screenOptions={{
          headerShown: false,
          tabBarActiveTintColor: colors.primary,
          tabBarInactiveTintColor: colors.textSecondary,
          tabBarLabelStyle: { fontFamily: fonts.semiBold, fontSize: 11 },
          tabBarStyle: { backgroundColor: colors.card, borderTopColor: colors.divider },
          sceneStyle: { backgroundColor: colors.background },
        }}
      >
        <Tabs.Screen
          name="index"
          options={{
            title: t('tabs.start'),
            tabBarIcon: ({ color, focused }) => (
              <Ionicons name={focused ? 'home' : 'home-outline'} size={22} color={color} />
            ),
          }}
        />
        <Tabs.Screen
          name="budget"
          options={{
            title: t('tabs.budget'),
            tabBarIcon: ({ color, focused }) => (
              <Ionicons name={focused ? 'wallet' : 'wallet-outline'} size={22} color={color} />
            ),
          }}
        />
        <Tabs.Screen
          name="goals"
          options={{
            title: t('tabs.goals'),
            tabBarIcon: ({ color, focused }) => (
              <Ionicons name={focused ? 'flag' : 'flag-outline'} size={22} color={color} />
            ),
          }}
        />
        <Tabs.Screen
          name="income"
          options={{
            title: t('tabs.income'),
            tabBarIcon: ({ color, focused }) => (
              <Ionicons name={focused ? 'trending-up' : 'trending-up-outline'} size={22} color={color} />
            ),
          }}
        />
        <Tabs.Screen
          name="policies"
          options={{
            title: t('tabs.policies'),
            tabBarIcon: ({ color, focused }) => (
              <Ionicons name={focused ? 'shield' : 'shield-outline'} size={22} color={color} />
            ),
          }}
        />
        <Tabs.Screen
          name="agent-panel"
          options={{
            // href:null removes the tab from the bar (and deep links) for clients.
            href: isAgent || isAdmin ? '/agent-panel' : null,
            title: t('tabs.agent'),
            tabBarIcon: ({ color, focused }) => (
              <Ionicons name={focused ? 'headset' : 'headset-outline'} size={22} color={color} />
            ),
          }}
        />
      </Tabs>
      <AddExpenseFab />
    </View>
  );
}
